export const compliance = {
list: {
  chaseFailedBody: "Prüfen Sie Ihre Verbindung und versuchen Sie es erneut. Klappt es weiter nicht, öffnen Sie das Dokument und prüfen Sie es selbst oder fragen Sie den Prüfer direkt.",
  chaseFailedTitle: "Erinnerung nicht gesendet",
  chaseSentBodyUnnamed: "Der Prüfer erhält eine Benachrichtigung zur Prüfung. Jede Person erhält höchstens eine Erinnerung pro Tag.",
  chaseSentBody: "{{name}} erhält eine Benachrichtigung zur Prüfung. Jede Person erhält höchstens eine Erinnerung pro Tag.",
  chaseSentTitle: "Erinnerung gesendet",
  showWorkspace: "Ganzen Arbeitsbereich zeigen",
  noWorkspaceDescription: "Compliance wird für einen Arbeitsbereich angezeigt. Treten Sie einem bei oder erstellen Sie einen, um sie hier zu sehen.",
title: "Konformität",
subtitle_one: "{{count}} Anforderung",
subtitle_other: "{{count}} Anforderungen",
searchPlaceholder: "Anlagen, Dokumente suchen",
searchA11y: "Konformität durchsuchen",
refine: "Filtern",
refineSheetTitle: "Konformität filtern",
clearFilters: "Filter zurücksetzen",
loadMore: "Mehr laden",
emptyTitle: "Noch nichts nachzuweisen",
emptyDescription: "Öffnen Sie eine Anlage und fügen Sie ein Zertifikat oder anderes Dokument mit Ablaufdatum hinzu. Es erscheint dann hier mit seiner Fälligkeit.",
emptyAction: "Zu den Anlagen",
noMatchTitle: "Keine passenden Anforderungen",
noMatchDescription: "Keine Konformitätsanforderungen entsprechen den angewendeten Filtern.",
errorTitle: "Konformität konnte nicht geladen werden",
unscopedTitle: "Workspace auswählen",
unscopedDescription: "Compliance gilt für den ganzen Arbeitsbereich, und Sie sehen nur Ihre eigenen Einträge. Tippen Sie auf Ganzen Arbeitsbereich zeigen.",
},
bucket: {
compliant: "OK",
expiring: "Läuft ab",
overdue: "Überfällig",
invalid: "Abgelehnt",
pending: "Wartet auf Validierung",
missing_evidence: "Fehlt",
unknown: "Unbekannt",
},
bucketA11y: {
compliant_one: "{{count}} konform",
compliant_other: "{{count}} konform",
expiring_one: "{{count}} läuft ab",
expiring_other: "{{count}} laufen ab",
overdue_one: "{{count}} überfällig",
overdue_other: "{{count}} überfällig",
invalid_one: "{{count}} abgelehnt",
invalid_other: "{{count}} abgelehnt",
pending_one: "{{count}} wartet auf Validierung",
pending_other: "{{count}} warten auf Validierung",
missing_evidence: "{{count}} ohne Nachweis",
unknown_one: "{{count}} unbekannt",
unknown_other: "{{count}} unbekannt",
},
state: {
overdue: "überfällig",
overdueBy_one: "{{count}} Tag überfällig",
overdueBy_other: "{{count}} Tage überfällig",
expiring: "läuft ab",
expiresToday: "läuft heute ab",
expiresIn_one: "läuft in {{count}} Tag ab",
expiresIn_other: "läuft in {{count}} Tagen ab",
evidenceMissing: "Nachweis fehlt",
rejected: "abgelehnt",
awaitingValidation: "wartet auf Validierung",
nothingRecorded: "nichts erfasst",
inDate: "gültig",
validFor_one: "gültig für {{count}} Tag",
validFor_other: "gültig für {{count}} Tage",
},
action: {
upload_evidence: "Nachweis hinzufügen",
renew: "Erneuern",
replace_rejected: "Ersetzen",
chase_validation: "Prüfer erinnern",
record_expiry: "Ablaufdatum hinzufügen",
review_asset: "Anlage prüfen",
none: "",
schedule_inspection: "Prüfen",
},
row: {
responsible: "Verantwortlich: {{name}}",
unassigned: "Kein benannter Freigeber",
sourceLocalRead: "Aus dem Dokument gelesen",
sourceCloudAi: "Von KI vorgeschlagen",
sourceManual: "Manuell eingegeben",
validatedBy: "Akzeptiert von {{name}}",
openA11y: "{{label}} auf {{asset}} öffnen",
},
refine: {
status: "Status",
site: "Standort",
siteAny: "Beliebiger Standort",
team: "Team",
teamAny: "Beliebiges Team",
assetType: "Anlagentyp",
asset: "Anlage",
requirement: "Anforderung",
due: "Fällig",
dueAny: "Jederzeit",
due30: "Nächste 30 Tage",
due90: "Nächste 90 Tage",
sortBy: "Sortieren nach",
groupBy: "Gruppieren nach",
},
sort: {
due_soonest: "Bald fällig zuerst",
severity: "Dringendste zuerst",
asset_az: "Anlage A-Z",
},
group: {
none: "Keine Gruppierung",
status: "Status",
asset: "Anlage",
site: "Standort",
requirement: "Anforderung",
noSite: "Kein Standort",
noRequirement: "Nichts angegeben",
partialCount: "{{count}}+",
},
assetDetail: {
viewRegister: "Konformität anzeigen",
},
esg: {
loading: "ESG-Kennzahlen werden geladen…",
loadFailed: "Die ESG-Kennzahlen konnten nicht geladen werden.",
retry: "Erneut versuchen",
notCoveredTitle: "ESG ist für diesen Standort nicht aktiv",
notCoveredBody: "Ihr Arbeitsbereich nutzt ESG nur für ausgewählte Standorte. Ein Admin kann diesen Standort unter Tarif und Abrechnung hinzufügen.",
noMetersTitle: "Noch keine Energie-Ablesungen",
noMetersBody: "Fügen Sie einem Asset einen Zähler hinzu (Strom, Gas, Öl, Wärme oder Wasser) und erfassen Sie Ablesungen. Energie und CO₂ erscheinen hier am nächsten Tag oder sofort über Aktualisieren.",
byFuelTitle: "Energie nach Energieträger (letzte 12 Monate)",
byMonthTitle: "Energie nach Monat",
byMonthA11y: "Balkendiagramm des Energieverbrauchs pro Monat in den letzten 12 Monaten",
unconverted: "Einige Ablesungen haben eine Einheit, die nicht in kWh umgerechnet werden kann, und werden nicht berücksichtigt. Prüfen Sie die Einheit des Zählers.",
estimateNote: "CO₂ ist eine Schätzung mit den Umrechnungsfaktoren der britischen Regierung ({{year}}). Scope 1 ist vor Ort verbrannter Brennstoff, Scope 2 ist eingekaufter Strom.",
updatedAt: "Berechnet {{when}}",
notYetComputed: "Noch nicht berechnet. Tippen Sie auf Aktualisieren.",
refresh: "Aktualisieren",
guideMe: "Anleitung",
refreshing: "Wird aktualisiert…",
edit: "Bearbeiten",
save: "Speichern",
cancel: "Abbrechen",
remove: "Entfernen",
saveFailed: "Speichern fehlgeschlagen. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
floorAreaTitle: "Nutzfläche",
floorAreaLabel: "Nutzfläche (m²)",
floorAreaHint: "Für Energie und CO₂ pro m². Untergeordnete Standorte nur einrechnen, wenn sie keine eigene Fläche haben.",
floorAreaInvalid: "Geben Sie eine Zahl in Quadratmetern ein.",
floorAreaValue: "{{m2}} m² Fläche",
kpi: {
energy: "Energie",
carbon: "CO₂",
intensity: "kWh pro m²",
intensityUnit: "letzte 12 Monate",
needsFloorArea: "Nutzfläche ergänzen",
meters: "Zähler mit Ablesung",
metersHint: "in den letzten 3 Monaten abgelesen",
water: "Wasser",
vsLastYear: "{{change}} gegenüber Vorjahr",
last12m: "letzte 12 Monate",
scopes: "Scope 1: {{s1}} · Scope 2: {{s2}}",
      same: "Unverändert",
      lower: "↓ {{pct}} %",
      higher: "↑ {{pct}} %",
      electricity: "Strom",
      electricityCarbon: "{{tonnes}} t CO₂e, letzte 12 Monate",
      refrigerant: "Kältemittel",
      refrigerantGwp: "{{refrigerant}}, GWP-Wert {{gwp}}",
      fgasSize: "F-Gas-Menge",
      fgasFormula: "{{kg}} kg × GWP-Wert {{gwp}}",
      fgasUnknownGwp: "GWP-Wert für dieses Gas unbekannt",
      leaked: "Ausgetreten, letzte 12 Monate",
      leakedTonnes: "{{tonnes}} t CO₂e ausgetreten",
      carbonCaption: "ggü. Vorjahr, Schätzung",
      vsLastYearShort: "ggü. Vorjahr",
      perM2: "Energie pro m²",
      perM2Caption: "letzte 12 Monate",
      allFuels: "alle Energieträger, letzte 12 Monate",
},
fuel: {
electricity: "Strom",
gas: "Gas",
heat: "Wärme",
oil: "Öl",
water: "Wasser",
},
refrigerant: {
title: "Kältemittel (F-Gase)",
none: "Kein Kältemittel erfasst.",
add: "Kältemittel hinzufügen",
summary_one: "{{count}} Asset enthält {{tonnes}} t CO₂e Kältemittel; {{inBand}} brauchen Dichtheitsprüfungen.",
summary_other: "{{count}} Assets enthalten {{tonnes}} t CO₂e Kältemittel; {{inBand}} brauchen Dichtheitsprüfungen.",
overdue_one: "{{count}} Dichtheitsprüfung ist überfällig.",
overdue_other: "{{count}} Dichtheitsprüfungen sind überfällig.",
assetLine: "{{refrigerant}}, {{kg}} kg ({{tonnes}} t CO₂-Äq.)",
checkEvery: "Dichtheitsprüfung alle {{months}} Monate. Nächste fällig {{next}}.",
noCheckNeeded: "Unter der F-Gas-Schwelle: keine regelmäßige Dichtheitsprüfung nötig.",
leakDetectionRequired: "Bei dieser Größe ist ein Leckage-Erkennungssystem vorgeschrieben.",
added12m: "{{kg}} kg in den letzten 12 Monaten nachgefüllt",
typeLabel: "Kältemittel",
chargeLabel: "Füllmenge (kg)",
chargeInvalid: "Geben Sie die Füllmenge in kg ein.",
leakDetection: "Leckage-Erkennung vorhanden",
hermetic: "Hermetisch geschlossen",
previewBand: "{{tonnes}} t CO₂e: Dichtheitsprüfung alle {{months}} Monate.",
previewNone: "{{tonnes}} t CO₂e: keine regelmäßige Dichtheitsprüfung nötig.",
planNote: "Wir nehmen die Dichtheitsprüfung in den Plan dieses Assets auf und halten das Intervall aktuell.",
logCheck: "Prüfung erfassen",
logLeak: "Leck erfassen",
logTopUp: "Nachfüllung erfassen",
logRecovered: "Rückgewinnung erfassen",
kgLabel: "Menge (kg)",
removeTitle: "Kältemittel entfernen?",
removeBody: "Der Prüfplan für dieses Asset endet. Das Protokoll früherer Prüfungen bleibt erhalten.",
      edit: "Kältemittel bearbeiten",
      fromDetails: "Gas aus den Anlagendetails: {{refrigerant}}",
},
epc: {
title: "Energieausweise",
none: "Kein Ausweis erfasst.",
add: "Ausweis hinzufügen",
ratingLabel: "Klasse",
validUntilLabel: "Gültig bis (JJJJ-MM-TT)",
validUntil: "gültig bis {{date}}",
dateInvalid: "Geben Sie das Datum als JJJJ-MM-TT ein.",
refLabel: "Ausweisnummer",
isLet: "Das Gebäude ist vermietet",
belowMinimum: "Unter E: Ein vermietetes Gebäude in England und Wales darf ohne Ausnahme nicht mit dieser Klasse vermietet werden.",
expired: "Abgelaufen",
expiresSoon: "Läuft in 6 Monaten ab",
documentNote: "Legen Sie den Ausweis selbst unter Dokumente als Energieausweis ab, damit vor Ablauf erinnert wird.",
removeTitle: "Diesen Ausweis entfernen?",
      let: "Vermietet",
      notLet: "Nicht vermietet",
      meetsStandard: "Erfüllt den Mindeststandard für Vermietung",
      open: "Ausweis öffnen",
      attachFile: "Datei anhängen",
      noFile: "Noch keine Datei angehängt",
      addRating: "Klasse eintragen",
      keptInDocuments: "Ausweise werden einmal unter Dokumente abgelegt. Klasse, Datum und Erinnerung kommen von dort.",
},
sg: {
title: "Soziales und Governance",
hint: "Aus Ihren Inspektionen und Aufträgen der letzten 12 Monate.",
compliance: "Konformität",
risk: "Durchschnittliches Risiko",
inspections: "Inspektionen",
signedOff: "{{done}} erledigt, {{signed}} abgezeichnet",
jobs: "Aufträge",
rework: "{{done}} erledigt, {{rework}} nachgearbeitet",
contractors: "Eingesetzte Auftragnehmer",
      tile: {
        contractors: "Eingesetzte Dienstleister",
        contractorsCaption: "Versicherung noch nicht erfasst",
        safety: "Gültige Sicherheitsnachweise",
        findings: "Mängel rechtzeitig behoben",
        signedOff: "Geplante Arbeiten abgenommen",
        ofCount: "{{done}} von {{total}}",
        nothingYet: "noch nichts zu zählen",
      },
},
promptTitle: "ESG und Nachhaltigkeit",
promptBody: "Energie, CO₂, Kältemittel und Energieausweise für jeden Standort und jedes Asset, berechnet aus den Ablesungen, die Sie bereits erfassen. Ein Zusatzmodul, pro Asset berechnet.",
promptAction: "Unter Tarif und Abrechnung hinzufügen",
promptAskAdmin: "Bitten Sie einen Admin, es hinzuzufügen.",
promptNotInApp: "In der App nicht käuflich.",
ai: {
title: "Zusammenfassen",
hint: "Eine kurze Zusammenfassung dieser Kennzahlen mit empfohlenen Maßnahmen. Jede Zahl stammt von oben.",
reader: {
manager: "Für mich",
landlord: "Für einen Vermieter",
investor: "Für einen Investor",
},
write: "Zusammenfassen",
again: "Neu schreiben",
writing: "Wird geschrieben…",
failed: "Zusammenfassung fehlgeschlagen. Versuchen Sie es erneut.",
noCredits: "Ihr Arbeitsbereich hat keine KI-Credits mehr.",
plainNote: "Einfache Zusammenfassung, kein KI-Credit verbraucht.",
actionsTitle: "Empfohlene Maßnahmen",
do: {
job: "Auftrag erstellen",
inspection: "Inspizieren",
reading: "Ablesung erfassen",
record: "Öffnen",
},
},
portfolio: {
title: "Portfolio-ESG",
hint: "Jeder oberste Standort, letzte 12 Monate.",
site: "Standort",
energy: "Energie",
change: "Änderung",
intensity: "kWh pro m²",
carbon: "CO₂",
epc: "Ausweis",
fgas: "F-Gase",
overdue: "überfällig",
belowMinimum: "unter E",
expiring: "läuft ab",
empty: "Noch keine Standorte.",
workspaceTitle: "Gesamter Arbeitsbereich",
},
    period: "{{from}} bis {{to}}",
    addFloorArea: "Fläche hinzufügen",
    addonBadge: "ESG-Zusatzmodul",
    promptTitleAsset: "ESG für diese Anlage",
    promptTitleSite: "ESG für diesen Standort",
    promptMeters_one: "Sie erfassen hier bereits {{count}} Zähler ({{kinds}}). Mit dem ESG-Zusatzmodul werden seine Ablesungen sofort zu Energie-, CO₂- und Vorjahreswerten.",
    promptMeters_other: "Sie erfassen hier bereits {{count}} Zähler ({{kinds}}). Mit dem ESG-Zusatzmodul werden ihre Ablesungen sofort zu Energie-, CO₂- und Vorjahreswerten.",
    promptNothingHidden: "Nichts, was Sie erfassen, wird verborgen oder geht verloren: Zähler, Ablesungen und Dokumente bleiben, wie sie sind.",
    header: {
      floorArea: "{{value}} m² Fläche",
      rating: "{{scheme}}-Klasse {{rating}}",
    },
    csv: {
      defaultName: "ESG-Daten",
    },
    actions: {
      exportCsv: "ESG als CSV exportieren",
      share: "ESG-Bericht teilen",
      openAsset360: "Anlage 360 öffnen",
      openSite360: "Standort 360 öffnen",
    },
    chart: {
      electricityTitle: "Strom nach Monat",
      energyTitle: "Energie nach Monat",
      subElectricity_one: "MWh, von {{count}} Zähler",
      subElectricity_other: "MWh, von {{count}} Zählern",
      subEnergy_one: "MWh, alle Energieträger, von {{count}} Zähler",
      subEnergy_other: "MWh, alle Energieträger, von {{count}} Zählern",
      a11y: "{{title}}: Balken für jeden der letzten 12 Monate, eine gestrichelte Linie für denselben Monat im Vorjahr",
      valueWithLastYear: "{{month}}: {{value}} MWh (Vorjahr {{last}} MWh)",
      value: "{{month}}: {{value}} MWh verbraucht",
      tapHint: "Tippen Sie auf einen Balken, um den Wert zu sehen.",
      thisYear: "Dieses Jahr",
      lastYear: "Vorjahr",
      metersReporting: "{{reporting}} von {{total}} Zählern melden (in den letzten 3 Monaten abgelesen)",
    },
    carbon: {
      title: "Woher das CO₂ kommt",
      sub: "Letzte 12 Monate, Schätzung mit Faktoren von {{year}}",
      scope: "Scope {{n}} (Bereich)",
      refrigerantLeak: "Kältemittelverlust, {{name}}",
      none: "Noch kein CO₂ berechnet. Erfassen Sie Zählerstände oder Kältemittelnachfüllungen.",
      fuelsTitle: "Energie nach Energieträger",
    },
    fgas: {
      titleWithEpc: "F-Gase und Energieausweise",
      none: "An diesem Standort ist kein Kältemittel erfasst.",
      row: "{{name}}: {{refrigerant}}, {{kg}} kg Füllmenge ({{tonnes}} t CO₂e)",
      overdue: "Dichtheitsprüfung überfällig",
      due: "Dichtheitsprüfung fällig am {{date}}",
      noCheck: "Keine Dichtheitsprüfung nötig",
      openJobFor: "Auftrag für {{name}} öffnen",
      bookFor: "Dichtheitsprüfung für {{name}} buchen",
      jobTitle: "F-Gas-Dichtheitsprüfung: {{name}}",
      jobDescription: "Dichtheitsprüfung der {{refrigerant}}-Anlage ({{kg}} kg, {{tonnes}} t CO₂e) durch eine zertifizierte Fachkraft. Ergebnis und nachgefülltes Kältemittel erfassen.",
    },
    leak: {
      title: "Dichtheitsprüfungen",
      sub: "Wie oft die F-Gas-Regeln eine Dichtheitsprüfung verlangen, nach Menge in t CO₂e.",
      every: "Alle {{months}} Monate",
      noneNeeded: "Nicht nötig",
      band: {
        none: "Unter 5 t",
        "5-50": "5 bis 50 t",
        "50-500": "50 bis 500 t",
        "500+": "Ab 500 t",
      },
      lastCheck: "Letzte Prüfung {{date}}: {{result}}",
      resultLeak: "Leck gefunden",
      resultPassed: "bestanden",
      noCheckYet: "Noch keine Dichtheitsprüfung erfasst.",
      overdue: "Überfällig seit {{date}}",
      nextDue: "Nächste fällig am {{date}}",
      openJob: "Auftrag öffnen",
      logTitle: "Leckprotokoll",
      logEmpty: "Noch nichts erfasst.",
      event: {
        leak_check: "Dichtheitsprüfung",
        leak_found: "Leck gefunden",
        top_up: "{{kg}} kg nachgefüllt",
        recovered: "{{kg}} kg zurückgewonnen",
      },
      showFewer: "Weniger anzeigen",
      seeAll: "Alle {{total}} anzeigen",
      callout: "Jede Nachfüllung zählt als Leck: kg × GWP-Wert wird zu den Scope-1-Emissionen addiert.",
    },
    units: {
      mwh: "{{value}} MWh",
      kwh: "{{value}} kWh",
      kg: "{{value}} kg",
      t: "{{value}} t",
      mwhAxis: "MWh",
    },
},
};
